// eslint-disable-next-line no-unused-vars
import React, { useEffect, useRef } from "react";
import effectsConfig from "../effects/effectsConfig"; // Steuerung der Effekte

const FireballEffect = () => {
  const canvasRef = useRef(null);
  const enabled = effectsConfig.fireball; // 🔥 Steuerung über Config

  useEffect(() => {
    if (!enabled) return; // Falls deaktiviert, wird nichts gestartet

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let width = (canvas.width = window.innerWidth);
    let height = (canvas.height = window.innerHeight);
    const fireballs = [];
    const numFireballs = 4; // Anzahl der Feuerbälle gleichzeitig

    class Fireball {
      constructor() {
        this.size = Math.random() * 15 + 10;
        this.speed = Math.random() * 6 + 3;
        this.trail = []; // 🔥 Speichert die Positionen für den Schweif
        this.alpha = 1;

        // Startpunkt (Zufällig von links oder rechts)
        this.x = Math.random() < 0.5 ? -this.size : width + this.size;
        this.y = Math.random() * height;
        this.angle = Math.random() * Math.PI * 2;

        this.speedX = Math.cos(this.angle) * this.speed;
        this.speedY = Math.sin(this.angle) * this.speed;
      }

      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        this.trail.push({ x: this.x, y: this.y }); // 🔥 Schweif-Position speichern

        if (this.trail.length > 10) {
          this.trail.shift(); // Älteste Position entfernen für weichen Effekt
        }

        this.alpha -= 0.002; // Langsames Verblassen

        if (
          this.x < -this.size ||
          this.x > width + this.size ||
          this.y < -this.size ||
          this.y > height + this.size ||
          this.alpha <= 0
        ) {
          return false;
        }
        return true;
      }

      draw() {
        // 🔥 Zeichne den Schweif (Trail-Effekt)
        for (let i = 0; i < this.trail.length; i++) {
          const pos = this.trail[i];
          const fade = i / this.trail.length; // Lässt den Schweif verblassen
          ctx.beginPath();
          ctx.arc(pos.x, pos.y, this.size * fade, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255, 69, 0, ${this.alpha * fade})`; // Rot-Orange Glow
          ctx.fill();
        }

        // 🔥 Zeichne den eigentlichen Feuerball
        ctx.beginPath();
        const gradient = ctx.createRadialGradient(
          this.x,
          this.y,
          this.size * 0.2,
          this.x,
          this.y,
          this.size
        );
        gradient.addColorStop(0, `rgba(255, 165, 0, ${this.alpha})`); // Helles Orange
        gradient.addColorStop(1, `rgba(255, 0, 0, ${this.alpha * 0.7})`); // Tiefes Rot
        ctx.fillStyle = gradient;
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    const createFireballs = () => {
      while (fireballs.length < numFireballs) {
        fireballs.push(new Fireball());
      }
    };

    const animate = () => {
      ctx.clearRect(0, 0, width, height);
      fireballs.forEach((fireball, index) => {
        if (!fireball.update()) {
          fireballs.splice(index, 1); // Entferne tote Feuerbälle
        }
        fireball.draw();
      });

      createFireballs();
      requestAnimationFrame(animate);
    };

    createFireballs();
    animate();

    const resize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [enabled]);

  return enabled ? (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 100, // Buttons bleiben klickbar
      }}
    />
  ) : null;
};

export default FireballEffect;
